import debounce from 'lodash.debounce'
import {useEffect, useState} from 'react'
import {useSelector} from 'react-redux'
import {IRootState} from '../../../../../redux/types'
import {IFilter} from '../../models/course'

function useHandleFilters() {
  const {
    globalFamilyId,
    globalBrandId,
    globalCountryId,
    globalLineId,
    globalRoleId,
    globalLanguageId,
    globalOrderById,
    globalTag
  } = useSelector((state: IRootState) => state.global)

  const [filters, setFilters] = useState<IFilter>({
    family_id: null,
    brand_id: null,
    line_id: null,
    country_id: null,
    role_id: null,
    language_id: null,
    orderby_id: 0,
    tag_id: null,
    coursetype_id: null,
    searchText: ''
  })

  useEffect(() => {
    setFilters({
      ...filters,
      family_id: globalFamilyId,
      brand_id: globalBrandId,
      line_id: globalLineId,
      country_id: globalCountryId,
      role_id: globalRoleId,
      language_id: globalLanguageId,
      orderby_id: globalOrderById,
      tag_id: globalTag
    })
  }, [
    globalFamilyId,
    globalBrandId,
    globalLineId,
    globalCountryId,
    globalRoleId,
    globalLanguageId,
    globalOrderById,
    globalTag
  ])

  const handleChangeFilter = (coursetype_id: number) => {
    setFilters({...filters, coursetype_id})
  }

  const handleContentSearch = debounce((event: any) => {
    const value = event.target.value
    if (value !== '' && value !== null) {
      const rawValue = value
        .normalize('NFD')
        .replace(/[\u0300-\u036f]/g, '')
        .toLowerCase()
      setFilters({...filters, searchText: rawValue})
    } else {
      setFilters({...filters, searchText: ''})
    }
  }, 500)

  return {
    filters,
    handleChangeFilter,
    handleContentSearch
  }
}

export default useHandleFilters
